import { render } from "./SericeItem.vue?vue&type=template&id=504e17bf&scoped=true"
import script from "./SericeItem.vue?vue&type=script&lang=js"
export * from "./SericeItem.vue?vue&type=script&lang=js"

import "./SericeItem.vue?vue&type=style&index=0&id=504e17bf&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504e17bf"]])

export default __exports__